<template>
  <v-container 
    v-if="!$apollo.loading && whiteLabelModules"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      v-if="!editMode"
      justify-center
      wrap
    >
      <v-flex
        v-if="whiteLabelModules && whiteLabelModules.length > 0"
        md12
      >
        <h2>{{ $t('whitelabel.modulesSettings') }}</h2>
        <v-card>
          <v-data-table
            class="text-no-wrap" 
            :headers="headers"
            :items="whiteLabelModules"
            :hide-default-footer="true"
            :mobile-breakpoint="900"
            :items-per-page="200"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                v-text="header.text"
              />
            </template>
            <template v-slot:item.name="{ item }">
              <b>{{ item.name }}</b>
            </template>
            <template v-slot:item.description="{ item }">
              <small>{{ item.description }}</small>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu 
                offset-y
                left
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    :disabled="!item.custom_config_schema"
                    outlined 
                    small
                    text
                    v-on="on"
                  >
                    {{ $t('globals.manageButton') }}
                  </v-btn>
                </template>
                <v-sheet dense>
                  <v-list-item
                    @click="editModule(item)"
                  >
                    <v-list-item-title>{{ $t('globals.editButton') }}</v-list-item-title>
                  </v-list-item>
                </v-sheet>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex
        v-else
        md5
        xs12
        new-record
      >
        <v-row>
          <v-col cols="12">
            <v-row
              justify="center"
              align="center"
            >
              <v-col>
                <v-card
                  style="padding:50px"
                >
                  <v-icon style="font-size: 100px;margin-bottom:20px;">
                    mdi-apps
                  </v-icon>
                  <h3>{{ $t('whitelabel.modulesSettings') }}</h3>
                  <p>{{ $t('modules.notFound') }}</p>
                  <v-btn
                    class="primary mt-3"
                    @click="$router.push(`/whitelabel/${getWhiteLabel.uuid}/edit`)"
                  >
                    {{ $t('whitelabel.visit') }}
                  </v-btn>
                </v-card> 
              </v-col>
            </v-row>
          </v-col>
        </v-row>    
      </v-flex>
    </v-layout>
    <edit-form
      v-if="editMode"
      :module="selectedItem"
      @closeEditMode="closeEditMode"
    />
  </v-container>
</template>

<script>
import NODULES_QUERY from "@/graphql/queries/Modules.gql";
import EditForm from "@/views/Modules/Configuration/NewOrEdit.vue";
import { mapGetters } from 'vuex'

export default {
  name: 'Modules',
  components: {
    EditForm
  },
  data() {
    return {
      loading: false,
      editMode: false,
      selectedItem: null,
      headers: [
        {
          sortable: false,
          text: this.$t('globals.name'),
          value: 'name'
        },
        {
          sortable: false,
          text: this.$t('globals.description'),
          value: 'description',
        },
        {
          sortable: false,
          text: '',
          value: 'actions',
        },
      ]
    }
  },
  computed: {
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
  },
  watch: {
    getWhiteLabel(val) {
      this.$apollo.queries.whiteLabelModules.refetch();
    }
  },
  methods: {
    editModule(item) {
      this.selectedItem = item
      this.editMode = true
    },
    closeEditMode(val) {
      if (val) {
        this.$apollo.queries.whiteLabelModules.refetch();
      }
      this.editMode = false
    }
  },
  apollo: {
    whiteLabelModules: {
      fetchPolicy: "no-cache",
      query() {
        return NODULES_QUERY;
      },
      variables() {
        return {
          whitelabel_uuid: this.getWhiteLabel.uuid,
        };
      },
      skip() {
        return !this.getWhiteLabel.uuid;
      },
    }
  }
}
</script>
<style lang="scss" scoped>
 
</style>
